var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckmarkBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9040",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37179",
    d: "M14.418 31.335a3.321 3.321 0 0 1-2.389-.993 221.81 221.81 0 0 1-1.814-1.835l-.747-.76A99.351 99.351 0 0 0 1.419 20.2a3.033 3.033 0 0 1-.751-4.465 3.677 3.677 0 0 1 2.9-1.47 3.372 3.372 0 0 1 1.951.617A18.411 18.411 0 0 1 7.54 16.53a759.434 759.434 0 0 1 5.178 4.941c.233-.607.467-1.2.722-1.784a51.344 51.344 0 0 1 5.61-9.552c1.965-2.732 4-5.473 5.974-8.124l.375-.5A3.532 3.532 0 0 1 30.647.9a2.954 2.954 0 0 1 .525 4.115 61.567 61.567 0 0 1-1.312 1.8c-.272.364-.553.741-.82 1.111-.574.792-1.16 1.593-1.728 2.367-1.389 1.895-2.825 3.854-4.162 5.818a33.379 33.379 0 0 0-4.881 10.209c-.189.71-.35 1.456-.478 2.215a3.1 3.1 0 0 1-2.257 2.638 4.129 4.129 0 0 1-1.116.161",
    transform: "translate(.113 .112)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkBig);
export default __webpack_public_path__ + "static/media/icon_checkmark_big.0a23559664f1c36416b4ab5ae448140f.svg";
export { ForwardRef as ReactComponent };